import { getOperation, putOperation } from "utils/api";

export const queryMerchant = async (params) => {
  return await getOperation("/merchant/list", {
    sort: "createdDate,desc",
    ...params,
  });
};

export const updateStatus = async (params) => {
  return await putOperation("/merchant/detail", {
    ...params,
  });
};
